/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-08 10:31:03
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title4 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P4 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        <Title4 pageNumber="1.3">安踏品牌历史累积数字品牌价值涨跌</Title4>

        <div className={s.content}>
          <div contentEditable className={s.subTitle}>增长速度逐渐加快，大型赛事和活动营销、明星代言的贡献最大</div>
          <div contentEditable className={s.des}>
            自2016.1.1至2022.12.31的7年中，
            安踏的数字品牌价值整体呈现增长趋势，
            2018年开始增长明显，
            近两年更是突飞猛进，
            截止2022年12月31日，
            累积数字品牌价值达到67.82亿DB（6,782,031,535DB）。其中，
            退出BCI并声明坚持使用新疆棉、王一博代言、东京奥运会、北京冬奥会营销等事件的广泛传播，
            使品牌的数字品牌价值实现了飞跃式的增长。
          </div>

          <div className={s.chartWrapper}>
            <TooltipDrawer
              style={{ width: '100%', height: '100%' }}
              formContent={<Form onChange={values => this.setState({ ...values })} />}>
              <Chart options={setChart({ title: chartTitle, list: chartList, color: chartColorList })} />
            </TooltipDrawer>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P4);



// WEBPACK FOOTER //
// src/routes/visualChart/P4/index.js